<script>
import HeaderPage from "@/components/web/common/header.vue";
import MenuPage from "@/components/web/common/menu.vue";

export default {
  name: "WebBaseLayout",
  components: { HeaderPage, MenuPage },
};
</script>

<template>
  <el-container>
    <el-header>
      <HeaderPage></HeaderPage>
    </el-header>
    <el-container class="content-area">
      <el-aside width="220px" class="nav-side">
        <MenuPage></MenuPage>
      </el-aside>
      <el-container>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<style scoped>
.el-container {
  height: 100vh;
  display: flex;
}
.el-container > .el-container {
  height: 100%;
  flex: 1;
  min-height: 0;
}
.el-container .el-header,
.el-footer {
  background-color: #0f1115;
  text-align: center;
  padding: 0;
  line-height: 60px !important;
  height: 60px !important;
  border-bottom: 1px solid rgba(99, 162, 120, 0.3);
}

.el-aside {
  color: #e0e0e0;
  text-align: center;
  background-color: transparent;
  padding: 20px 15px;
}

.el-main {
  color: #e0e0e0;
  text-align: center;
  line-height: 50px;
  flex: 1;
  overflow: auto;
  padding: 30px 40px;
}

.content-area {
  background-color: #0f1115;
}

.nav-side {
  border-right: 1px solid rgba(99, 162, 120, 0.3);
  background-color: rgba(15, 17, 21, 0.5);
}
</style>
